import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { firebaseAuth } from './firebase/firebase-config'
import VueSweetalert2 from 'vue-sweetalert2'
import slugify from 'slugify'
import VTooltip from 'v-tooltip'
import MapboxGL from 'mapbox-gl'
import MapboxSDK from '@mapbox/mapbox-sdk'
import axios from 'axios'
import { firestorePlugin } from 'vuefire'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import ToggleButton from 'vue-js-toggle-button'
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import VueSocialSharing from 'vue-social-sharing'
import { Datetime } from 'vue-datetime'

/*
**  Import all vendor libraries
*/

import jquery from 'jquery'
import moment from 'moment'
import autogrow from 'autogrow'
import vueHljs from 'vue-hljs'

import 'vue-hljs/dist/vue-hljs.min.css'
import 'simplebar/dist/simplebar.min.css'
import 'vue-datetime/dist/vue-datetime.css'

/*
**  Make libraries globally accessible
*/

window.$ = jquery
window.moment = moment
window.slugify = slugify
window.VueSweetalert2 = VueSweetalert2
window.MapboxGL = MapboxGL
window.MapboxSDK = MapboxSDK
window.axios = axios
window.vueFilePond = vueFilePond
window.FilePondPluginFileValidateType = FilePondPluginFileValidateType
window.FilePondPluginFileValidateSize = FilePondPluginFileValidateSize
window.FilePondPluginImagePreview = FilePondPluginImagePreview

/*
**  Set Bugsnag config options
*/

/*
**  Vue use statements
*/

Vue.use(VueSweetalert2)
Vue.use(VTooltip)
Vue.use(firestorePlugin)
Vue.use(ToggleButton)
Vue.use(vueHljs)
Vue.use(VueSocialSharing)
Vue.use(Datetime)


/*
**  Import all of the static styles
*/

require('./assets/css/foundation.css')
require('./assets/css/animated.css')
require('./assets/css/sweetalert2.css')
require('./assets/css/filepond.min.css')
require('./assets/css/filepond-plugin-image-preview.css')

/*
**  Import all of the app styles
*/

require('../styles/app.scss')

/*
** Set production tips to false
*/

Vue.config.productionTip = false

/*
** Start Bugsnag
*/

window.bugsnagClient = Bugsnag.start({
	apiKey: process.env.VUE_APP_BUGSNAG_KEY,
  	plugins: [new BugsnagPluginVue()],
  	releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
  	appVersion: process.env.VUE_APP_RELEASE_MILESTONE
});


Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

/*
** Wrap the vue instance in firebase auth state
*/

let app = null;

firebaseAuth.onAuthStateChanged(() => {

	// Init app if not already created
	if(!app) {

		app = new Vue({
			router,
			render: h => h(App)
		}).$mount('#app')

	}

});

